export interface IDeveloperGaProduct {
  brand: string;
  dealType: string;
  name: string;
  objectType: string;
}

export function createDeveloperGaProduct(id: number, name: string): IDeveloperGaProduct {
  return {
    brand: `${id}/developer`,
    dealType: 'sale',
    name,
    objectType: 'Builder',
  };
}
